import { store } from '@/main'
import 'waypoints/lib/noframework.waypoints'

export const MySectionClass = {
  inserted: (el) => {
    const waypoints = {}
    waypoints.down = new Waypoint({
      element: el,
      handler (direction) {
        let currentIndex = store.state.sections.indexOf(el.id)
        let previousSection = store.state.sections[currentIndex - 1]
        if (direction === 'down') {
          store.commit('setSection', el.id)
        } else {
          store.commit('setSection', previousSection)
        }
      },
      offset: '30%'
    })
    // waypoints.up = new Waypoint({
    //   element: el,
    //   handler (direction) {
    //     if (direction === 'up') {
    //       // console.log(-el.clientHeight + parseInt(window.innerHeight / 5, 10))
    //       store.commit('setSection', el.id)
    //     }
    //   },
    //   offset: () => {
    //     return -el.clientHeight + parseInt(window.innerHeight / 5, 10)
    //   }
    // })
  }
}



// WEBPACK FOOTER //
// ./src/directives/my-section-class.js